import React from 'react';

import Box from '../Box'

export default props => {
	const isPlaceholder = !!window.APP_SETTINGS?.placeholder;
	return (
		<section className="container">
			<Box {...props} id="b1" type="BTextOnPicture" settings={props.settings.b1} preserveImageRatio={isPlaceholder ? false : true} classes="" />
		</section>
	);
}
